export const clearAuth = () => {
  sessionStorage.setItem("id", "");
  sessionStorage.setItem("name", "");
  sessionStorage.setItem("roleJson", "");
  sessionStorage.setItem("rk", "");
  sessionStorage.setItem("pkm2", "");
  sessionStorage.setItem("pke2", "");
};

export const setAuth = auth => {
  sessionStorage.setItem("id", auth.id);
  sessionStorage.setItem("name", auth.name);
  sessionStorage.setItem("roleJson", auth.roleJson);
  sessionStorage.setItem("rk", auth.rk);
  sessionStorage.setItem("pkm2", auth.pkm2);
  sessionStorage.setItem("pke2", auth.pke2);
};
